function validateEmail(email) {  
    if (!email.trim()) {
        return {
            isValid: false,
            message: 'Email cannot be empty'
        }
    }

    const isValidEmail = String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );

    if (!isValidEmail) {
        return {
            isValid: false,
            message: 'Email is incorrect'
        }
    }

    return {
        isValid: true,
        message: ''
    }
};

export {
    validateEmail
};
